
import React, { Component } from 'react';
import Pause from 'components/Pause';
import AudioPlayer from 'components/AudioPlayer';
import strings from 'strings';
import ReadyButton from 'components/ReadyButton';
import introAfter from '../../assets/sounds/se/intros/SM_Intro-AFTER-trial.mp3';

class PauseAfterTrial extends Component {
	constructor(props) {
		super(props);
		this.audio = introAfter;
	}
	render() {
		return (
			<>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{strings.sm_intro_after_trial_2}
				</p>
				<p>{strings.sm_intro_after_trial_3}</p>
				<ReadyButton onReadyChange={this.props.setReady} />
			</>
		);
	}
}

export default PauseAfterTrial;
